import { useNavigate } from 'react-router-dom'

import { BaseBanner } from '@factorialco/f0-react/dist/experimental'
import PreviewWithExpenses from 'assets/images/finance/insights/banner-with-expenses.png'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

interface Props {
  title?: string
  description?: string
  source: string
  restoreVisibiltyOnNextDay?: boolean
}

export const FinancialWorkspacePromotionBanner = ({
  title = i18n.t('finance.financial_workspace.promotion_banner.title'),
  description = i18n.t('finance.financial_workspace.promotion_banner.description'),
  source,
}: Props) => {
  const [isHidden, setIsHidden] = useLocalStorage<boolean>(`factorial:fw-promotion-${source}`)
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const clickLink = () => {
    track(trackingEvents.accounting.newFinancialWorkspace.bannerLinkClicked, {
      source,
    })

    navigate(navigation.finance.financial_workspace.employee_costs.fullPath())
  }

  const trackBannerViewed = useUnsafeCallback(() => {
    track(trackingEvents.accounting.newFinancialWorkspace.bannerViewed, {
      source,
    })
  }, [source])

  const onClose = () => {
    track(trackingEvents.accounting.newFinancialWorkspace.bannerClosed, {
      source,
    })

    setIsHidden(true)
  }

  useUnsafeEffect(() => {
    if (!isHidden) {
      trackBannerViewed()
    }
  }, [trackBannerViewed, isHidden])

  if (isHidden) return null

  return (
    <BaseBanner
      title={title}
      subtitle={description}
      mediaUrl={PreviewWithExpenses}
      secondaryAction={{
        label: i18n.t('finance.financial_workspace.promotion_banner.link'),
        onClick: clickLink,
      }}
      onClose={onClose}
    />
  )
}
